import React, { Fragment, useEffect, useState, useRef } from "react";
import SaveEditFirst from "../SaveEdit/SaveEditFirst";
import TextareaSubmit from "./TextareaSubmit";
import useKeyboardShortcuts from "../../../hooks/KeysHandle/useKeyboardShortcuts";
import WithPortal from "../../UniversalComponents/WithPortal";
import DatePickerComponent from "../../UniversalComponents/DatePickerComponent";
import moment from "moment";
import { createPortal } from "react-dom";
import { ReactComponent as ClockImg } from "../../../../src/assets/images/icons/ClockTracking.svg";
import LabelComponent from "../../UniversalComponents/LabelComponent";
import { parseAndExtract, safeJsonParse } from "../../../utils/utilityFunctions/stringUtility";

const InputFieldCopy = ({
  // tableidclass,
  FieldType,
  FieldValue,
  FieldChange = () => {},
  setDataInputRow,
  UpdateTableField,
  Item,
  // Header,
  // clientCoord,
  cell,
  isTracking,
  meta,
  className = "p-3 w-full h-[33px]",
}) => {
  const [inputvalue, setInputValue] = useState("");

  const inputRef = useRef(null);

  useEffect(() => {
    if (FieldType === "date" && FieldValue) {
      if (meta?.dateTimeFormat?.timeDisplay) {
        const m = moment(FieldValue, ["DD MMM YYYY HH:mm", "DD MMM YYYY"], true);
        if (!m.isValid()) {
        } else {
          const hasTime = FieldValue.trim().length > 11;

          const timeStr = hasTime ? m.format("HH:mm") : "00:00";

          setSelectedTime(timeStr);
        }
      }
      setInputValue(FieldValue);
    } else if (FieldType === "number") {
      if (FieldValue) setInputValue(parseFloat(FieldValue));
    } else {
      if (meta?.textFormat?.textSelectedOption === "Hyperlink") {
        setInputValue(safeJsonParse(FieldValue));
      } else {
        setInputValue(FieldValue);
      }
    }
  }, [FieldValue, FieldType]);

  const generateTimeOptions = () => {
    const times = [];
    for (let i = 0; i < 24; i++) {
      const hour = i < 10 ? `0${i}` : i;
      times.push(`${hour}:00`);
      times.push(`${hour}:30`);
    }
    return times;
  };

  const [selectedTime, setSelectedTime] = useState("00:00");

  const handleTimeChange = (e) => {
    const newTime = e.target.value;
    setSelectedTime(newTime);

    // Optional: propagate it to parent or table update logic if needed
    // UpdateTableField(e, newTime, Item, cell, FieldType);
  };

  const startTimeElement = () => {
    return (
      <div className="flex w-full relative">
        <select
          name="timeDisplay"
          value={selectedTime}
          onChange={handleTimeChange}
          className={`
           h-[25px] rounded-md border border-gray-300 focus:outline-none focus:ring-0 focus:border-[#7A7D84] w-full text-sm py-0 pr-10 bg-white text-black appearance-none [&::-ms-expand]:hidden min-w-fit`}
          style={{
            backgroundImage: "none",
          }}
        >
          {generateTimeOptions().map((time) => (
            <option key={time} value={time}>
              {time.slice(0, 5)}
            </option>
          ))}
        </select>

        <div className="absolute right-[1.5px] top-1/2 transform -translate-y-1/2 pointer-events-none pr-1">
          <ClockImg />
        </div>
      </div>
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let newValue;

    if (meta?.textFormat?.textSelectedOption === "Hyperlink") {
      setInputValue((prev) => {
        return {
          ...prev,
          [name]: value,
        };
      });
    }

    // 1. If it's a raw date object (e.g. from react-datepicker)
    else if (FieldType === "date" && e instanceof Date) {
      newValue = e.toISOString().split("T")[0];
      setInputValue(newValue);
      FieldChange({ target: { value: newValue + selectedTime } });

      // 2. If it's a normal HTML event
    } else if (e && e.target) {
      newValue = e.target.value;

      if (FieldType === "date") {
        const parsedDate = new Date(newValue + selectedTime);
        const formatted = parsedDate.toISOString().split("T")[0];

        setInputValue(formatted);
        FieldChange({ target: { value: formatted } });
      } else if (FieldType === "number") {
        setInputValue(newValue);
        FieldChange({ target: { value: parseFloat(newValue) } });
      } else {
        const limitedText = newValue?.slice(0, 200);
        setInputValue(limitedText);
        FieldChange({ target: { value: limitedText } });
      }
    } else {
      console.error("Invalid input passed to handleChange:", e);
    }
  };

  const handleDateChange = (date) => {
    if (FieldType === "date") {
      // const formattedDate = date ? date.toISOString().split("T")[0] : "";
      setInputValue(date);
    }
  };

  const textareaRef = useRef(null);

  const pressEnterRemotely = () => {
    const event = new KeyboardEvent("keydown", {
      bubbles: true,
      cancelable: true,
      key: "Enter",
      code: "Enter",
      keyCode: 13,
      which: 13,
    });

    textareaRef?.current?.dispatchEvent(event);
  };

  useKeyboardShortcuts({
    Enter: (event) => {
      event.preventDefault();
      if (FieldType === "number") {
        UpdateTableField(event, inputvalue, Item, FieldValue);
      } else if (meta?.textFormat?.textSelectedOption === "Hyperlink") {
        if (!inputvalue?.url || !inputvalue?.textForUrl) {
          // If either url or textForUrl is missing, set field to null
          UpdateTableField(event, null, Item, cell, FieldValue);
        } else {
          UpdateTableField(event, inputvalue, Item, cell, FieldValue);
        }
      } else {
        UpdateTableField(event, inputvalue, Item, cell, FieldValue);
      }
    },
    Escape: (event) => {
      event.preventDefault();
      setDataInputRow(null);
    },
  });

  useEffect(() => {
    if (FieldType === "number" && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select(); // Optional: select text
    }
  }, [FieldType]);

  if (FieldType === "number") {
    return (
      <Fragment>
        <input
          type={FieldType}
          autoFocus
          value={inputvalue}
          onChange={handleChange}
          className={className}
          onKeyDown={(e) => {
            if (["e", "E", "+"].includes(e.key)) {
              e.preventDefault();
            }
          }}
          onPaste={(e) => {
            const pasted = e.clipboardData.getData("text");
            if (/[eE+-]/.test(pasted)) {
              e.preventDefault();
            }
          }}
        />

        <SaveEditFirst
          UpdateTableField={(e) => UpdateTableField(e, parseFloat(inputvalue), Item, cell, FieldValue)}
          handleCloseClick={(e) => {
            e.stopPropagation();
            setDataInputRow(null);
          }}
        />
      </Fragment>
    );
  } else if (FieldType === "date") {
    return (
      <>
        <input
          ref={inputRef}
          className={`p-3 h-[33px]  bg-white ${isTracking ? "w-full" : "w-full"} truncate cursor-not-allowed text-ellipsis overflow-hidden`}
          disabled
          readOnly
          value={FieldValue}
        />
        <WithPortal
          open={true}
          onClose={() => {
            pressEnterRemotely();
          }}
          containerRef={inputRef}
        >
          <div
            className={`flex items-center px-2 py-4 ${meta?.dateTimeFormat?.timeDisplay === "Date & Time" ? "justify-end" : "justify-center"}`}
          >
            <SaveEditFirst
              UpdateTableField={(e) => {
                // const formattedDate = moment(inputvalue).format("YYYY-MM-DD");
                const timeParts = selectedTime.split(":"); // e.g. ["14", "30", "00"]
                const formattedDate =
                  meta?.dateTimeFormat?.timeDisplay === "Date & Time"
                    ? moment(inputvalue)
                        .hour(parseInt(timeParts[0], 10))
                        .minute(parseInt(timeParts[1], 10))
                        .second(timeParts[2] ? parseInt(timeParts[2], 10) : 0)
                        .format("DD MMM YYYY HH:mm")
                    : moment(inputvalue).format("DD MMM YYYY");

                UpdateTableField(e, formattedDate, Item, cell, FieldType);
              }}
              handleCloseClick={(e) => {
                e.stopPropagation();
                setDataInputRow(null);
              }}
            />
            {meta?.dateTimeFormat?.timeDisplay === "Date & Time" ? (
              <div className="flex  justify-end gap-2">
                <span>
                  <LabelComponent htmlFor="time_input" labelText="Date" size="small" />
                  <DatePickerComponent
                    FieldType="date"
                    name="dob"
                    selected={inputvalue ? moment(inputvalue, "DD MMM YYYY").toDate() : null}
                    onChange={handleDateChange}
                    selectsStart
                    // startDate={inputvalue ?  moment(inputvalue, "DD-MM-YYYY").toDate() : null}
                    dateFormat="dd MMM yyyy"
                    placeholderText="DD MM YYYY"
                    autoOpen
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={500}
                    size={isTracking ? "small" : "small"}
                    border="hidden"
                    popperContainer={({ children }) => createPortal(children, document.getElementById("portal-root"))}
                  />
                </span>
                <span>
                  <LabelComponent htmlFor="time" labelText="Time" size="small" />
                  <div className=" flex relative w-[100%]">{startTimeElement()}</div>
                </span>
              </div>
            ) : (
              <span>
                <DatePickerComponent
                  FieldType="date"
                  name="dob"
                  selected={inputvalue ? moment(inputvalue, "DD MMM YYYY").toDate() : null}
                  onChange={handleDateChange}
                  selectsStart
                  // startDate={inputvalue ?  moment(inputvalue, "DD-MM-YYYY").toDate() : null}
                  dateFormat="dd MMM yyyy"
                  placeholderText="DD MM YYYY"
                  autoOpen
                  showYearDropdown
                  showMonthDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={500}
                  size={isTracking ? "small" : "small"}
                  border="hidden"
                  popperContainer={({ children }) => createPortal(children, document.getElementById("portal-root"))}
                  isTracking={isTracking}
                />
              </span>
            )}
          </div>
        </WithPortal>
      </>
    );
  } else {
    return (
      <>
        <input
          ref={inputRef}
          className={`p-3 h-[33px]  bg-white ${isTracking ? "w-full" : "w-fit"}  cursor-not-allowed text-ellipsis overflow-hidden truncate`}
          disabled
          readOnly
          value={parseAndExtract(FieldValue, "textForUrl", true)}
        />

        <WithPortal
          open={true}
          onClose={() => {
            pressEnterRemotely();
          }}
          containerRef={inputRef}
        >
          <TextareaSubmit
            Value={inputvalue}
            onChange={handleChange}
            meta={meta}
            handleSaveEvent={(e) => {
              UpdateTableField(e, { value: FieldType === "number" ? parseInt(inputvalue) : inputvalue }, Item);
            }}
            textareaRef={textareaRef}
          />
        </WithPortal>
      </>
    );
  }
};
export default InputFieldCopy;
